import { createFileRoute } from '@tanstack/react-router';
import { FloorplanSettings } from '@/features/storage/FloorplanSettings';

export const Route = createFileRoute('/_shell/storage/floorplan-settings/$floorplanId')({
  component: SettingsRoute,
});

function SettingsRoute() {
  const { floorplanId } = Route.useParams();
  return <FloorplanSettings key={floorplanId} floorplanId={floorplanId} />;
}
